import styled from '@emotion/styled';
import {Typography} from '@mui/material';

export const DateGroupContainerOneOff = styled.div(
  ({formError, isActive, theme}) => {
    const border = (isActive && formError?.length > 0) ?
    `border: 1px solid ${theme.palette.error.dark};` :
    isActive ?
    `border: 1px solid ${theme.palette.common.swatch[60]};` :
    '';

    return `
      border-radius: 8px;
      padding: ${(isActive) ? '4px 11px' : '5px 12px'};
      ${border}
      ${(!isActive) ? `background-color: ${theme.palette.common.swatch[20]};` : ''}
      ${(!isActive) ? `color: ${theme.palette.common.swatch[60]};` : ''}
    `;
  }
);

export const DateGroupContainerRecurring = styled.div(
  (props) => `
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 8px;
    padding: ${(props.isActive) ? '4px 11px' : '5px 12px'};
    ${(props.isActive) ? `border: 1px solid ${props.theme.palette.common.swatch[60]};` : ''}
    ${(!props.isActive) ? `background-color: ${props.theme.palette.common.swatch[20]};` : ''}
    ${(!props.isActive) ? `color: ${props.theme.palette.common.swatch[60]};` : ''}
  `
);

export const DateGroupTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: start;
`;

export const DateGroupSegment = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
`;

export const SegmentInputSeparator = styled.div`
  line-height: 1rem;
  font-size: .75rem;
  font-weight: 500;
  margin-top: 2px;
`;

export const BtnPlaceHolder = styled.div`
  height: 32px;
  width: 32px;
`;

export const DateGroupSegmentActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 75px;
`;

export const TypographyErrorMsg = styled(Typography)(({theme}) => ({
  color: '#DA1639',
  fontWeight: 400,
  fontSize: '.75rem',
  lineHeight: '1rem',
}));
